


























































import firebase from 'firebase/app';
import Vue from 'vue';

interface Booking {
  id: string;
  name: string;
  location: Location;
}

interface Location {
  id: string;
  name: string;
  building: Building;
}

interface Building {
  id: string;
  name: string;
}

interface LogLine {
  data: string;
  timestamp: Date;
}

const db = firebase.firestore();

export default Vue.extend({
  name: 'Overview',
  data: (): {
    error?: Error;
    buildingLog: LogLine[];
    buildings: Building[];
    bookingLog: LogLine[];
    bookings: Booking[];
    locationLog: LogLine[];
    locations: Location[];
  } => ({
    error: undefined,
    bookingLog: [],
    bookings: [],
    buildingLog: [],
    buildings: [],
    locationLog: [],
    locations: [],
  }),
  async created() {
    try {
      await this.$bind('bookings', db.collection('bookings').orderBy('name', 'asc'), { wait: true });
      await this.$bind('locations', db.collection('locations').orderBy('name', 'asc'), { wait: true });
      await this.$bind('buildings', db.collection('buildings').orderBy('name', 'asc'), { wait: true });
    } catch (e) {
      console.log('err', e);
      this.error = e;
    }
  },
  watch: {
    bookings: {
      immediate: true,
      deep: true,
      handler(bookings: Booking[]) {
        this.bookingLog.unshift({ timestamp: new Date(), data: JSON.stringify(bookings, null, 2) });
      },
    },
    buildings: {
      immediate: true,
      deep: true,
      handler(buildings: Building[]) {
        this.buildingLog.unshift({ timestamp: new Date(), data: JSON.stringify(buildings, null, 2) });
      },
    },
    locations: {
      immediate: true,
      deep: true,
      handler(locations: Location[]) {
        this.locationLog.unshift({ timestamp: new Date(), data: JSON.stringify(locations, null, 2) });
      },
    },
  },
  methods: {
    format(date: Date): string {
      return `${Intl.DateTimeFormat('en-US', {
        hour: 'numeric',
        minute: 'numeric',
        second: 'numeric',
      }).format(date)} + ${date.getMilliseconds()}ms`;
    },
    async reset() {
      await Promise.all([
        ...((await this.$firestoreRefs.buildings.get()) as firebase.firestore.QuerySnapshot<
          firebase.firestore.DocumentData
        >).docs.map(doc => doc.ref.delete()),
        ...((await this.$firestoreRefs.locations.get()) as firebase.firestore.QuerySnapshot<
          firebase.firestore.DocumentData
        >).docs.map(doc => doc.ref.delete()),
        ...((await this.$firestoreRefs.bookings.get()) as firebase.firestore.QuerySnapshot<
          firebase.firestore.DocumentData
        >).docs.map(doc => doc.ref.delete()),
      ]);
      await this.addBuilding();
      await this.addLocation();
      await this.addBooking();
      this.$router.go(0);
    },
    async addBuilding() {
      try {
        await db.collection('buildings').add({ name: `Building ${this.buildings.length + 1}` });
      } catch (e) {
        this.error = e;
      }
    },
    async addLocation() {
      try {
        const index = this.locations.length + 1;
        const building = this.buildings[Math.min(this.locations.length, this.buildings.length - 1)];
        await db.collection('locations').add({
          name: `Location ${index}`,
          building: db.collection('buildings').doc(building.id),
        });
      } catch (e) {
        this.error = e;
      }
    },
    async addBooking() {
      try {
        const index = this.bookings.length + 1;
        const location = this.locations[Math.min(this.bookings.length, this.locations.length - 1)];
        await db.collection('bookings').add({
          name: `Booking ${index}`,
          location: db.collection('locations').doc(location.id),
        });
      } catch (e) {
        this.error = e;
      }
    },
    async removeBuilding() {
      try {
        const docs = ((await this.$firestoreRefs.buildings.get()) as firebase.firestore.QuerySnapshot<
          firebase.firestore.DocumentData
        >).docs;
        docs[docs.length - 1].ref.delete();
      } catch (e) {
        this.error = e;
      }
    },
    async removeLocation() {
      try {
        const docs = ((await this.$firestoreRefs.locations.get()) as firebase.firestore.QuerySnapshot<
          firebase.firestore.DocumentData
        >).docs;
        docs[docs.length - 1].ref.delete();
      } catch (e) {
        this.error = e;
      }
    },
    async removeBooking() {
      try {
        const docs = ((await this.$firestoreRefs.bookings.get()) as firebase.firestore.QuerySnapshot<
          firebase.firestore.DocumentData
        >).docs;
        docs[docs.length - 1].ref.delete();
      } catch (e) {
        this.error = e;
      }
    },
  },
});
